<template>

  <b-modal v-model="showModal"
           size="md"
           no-close-on-backdrop
           hide-footer
           :title="`${$t('labels.balance')}`">

    <div v-if="fetchingBalances" class="d-flex justify-content-center align-items-center p-1">
      <b-spinner type="grow"></b-spinner>
    </div>

    <div v-else-if="balanceList.length > 0" class="mb-2">

      <div class="d-flex justify-content-end" style="padding-bottom: 13px;padding-right: 13px;padding-top: 2px">
        <b-form-checkbox v-model="activeStatus"
                         @change="filterActive()">
          {{ $t("labels.activeStatus") }}
        </b-form-checkbox>
      </div>

      <b-list-group
          v-for="(item,index) in balanceList" :key="index">

        <b-list-group-item :variant="item.active ? 'success' : 'danger'"
                           class="d-flex justify-content-between align-items-center"
                           style="margin-bottom: 5px;padding-left: 5px !important;">

          <div class="d-flex flex-row align-items-center">

            <coin-avatar :abv="item.abv" variant="silver" style="width: 30px"/>

            <div class="d-flex flex-column justify-content-start">
              <div>{{ item.name }}</div>
              <div class="font-small-2">{{
                  item.active ? $t("labels.activeStatus") : $t("labels.inactiveStatus")
                }}
              </div>
            </div>

          </div>

          <div :class="item.active ? 'text-success' : 'text-danger'">
            {{ $n(item.balance, 'currency') }}
          </div>

        </b-list-group-item>

      </b-list-group>

    </div>

    <div v-else class="p-1 d-flex justify-content-center">Error</div>

  </b-modal>

</template>

<script>
import {VueGoodTable} from 'vue-good-table'
import {
  BCollapse,
  BCard,
  BAvatar,
  BBadge,
  BButton,
  BCol,
  BListGroup,
  BListGroupItem,
  BOverlay,
  BRow,
  BSpinner,
  VBModal,
  BFormGroup,
  BFormCheckbox
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import {mapActions} from 'vuex'
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import CoinAvatar from '../currencies/CoinAvatar'

export default {
  name: "AllBalance",
  components: {
    BCollapse,
    CoinAvatar,
    BFormGroup,
    ValidationProvider,
    ValidationObserver,
    VueGoodTable,
    BAvatar,
    BBadge,
    BListGroupItem,
    BListGroup,
    VBModal,
    BButton,
    vSelect,
    BOverlay,
    BSpinner,
    BRow,
    BCol,
    BCard,
    BFormCheckbox
  },

  directives: {
    'b-modal': VBModal,
    Ripple,
  },

  data() {
    return {
      showModal: false,
      balanceList: [],
      balanceListCopy: [],
      fetchingBalances: true,
      activeStatus: false
    }
  },

  methods: {
    ...mapActions('user', ['showAllUserBalance']),
    ...mapActions('client', ['showAllClientBalance']),

    formatCurrency(price){

      if (!Number.isNaN(price))
        return new Intl.NumberFormat().format(price)
    },

    showAllBalanceModal(entityData, type) {

      if (type === 'CLIENT')
        this.getAllClientBalance(entityData._id)
      else
        this.getAllUserBalance(entityData._id)

      this.showModal = true

    },

    getAllClientBalance(clientId) {
      this.fetchingBalances = true
      this.showAllClientBalance({clientId})
          .then(response => {
            this.balanceList = response
            this.balanceListCopy = response
            this.fetchingBalances = false
          })
          .catch(error => {
            console.info(error)
            this.balanceList = []
            this.showModal = false
          })
    },

    getAllUserBalance(userId) {
      this.fetchingBalances = true
      this.showAllUserBalance({userId})
          .then(response => {
            this.balanceList = response
            this.balanceListCopy = response
            this.fetchingBalances = false
          })
          .catch(error => {
            console.info(error)
            this.balanceList = []
            this.showModal = false
          })
    },

    filterActive(){
      if (this.activeStatus)
        this.balanceList = this.balanceListCopy.filter(balance => balance.active == true)
      else
        this.balanceList = this.balanceListCopy

    }

  }

}

</script>

<style scoped>

</style>